'use client';

import { c as _c } from "react/compiler-runtime";
import { Card, CardBody, CardHeader, Button, Chip, Divider } from '@heroui/react';
import { Icon } from '@iconify/react';
import { Address } from 'viem';
import { motion } from "motion/react";
import type { LiquidityPosition } from '@/hooks/liquidity/useLiquidityPositions';
import type { TokenDataAllType } from '@/constants/types/currency';
import { formatNumber } from '@/util/balance/formatNumber';
import { TokenLogo } from '@/components/Tokens/TokenLogo';
import { DEX_LIST } from '@/constants/project-specific/farms/dex';
interface ExistingPositionSectionProps {
  position: LiquidityPosition;
  tokenData?: Record<Address, TokenDataAllType>;
  onRemoveClick?: (position: LiquidityPosition) => void;
  className?: string;
}
export function ExistingPositionSection(t0) {
  const $ = _c(98);
  const {
    position,
    onRemoveClick,
    className
  } = t0;
  const dexInfo = DEX_LIST[position.dex];
  const getStatusColor = _temp;
  const getStatusText = _temp2;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 0,
      y: 20
    };
    t2 = {
      opacity: 1,
      y: 0
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CardHeader className="pb-2"><div className="flex items-center justify-between w-full"><div className="flex items-center gap-3"><Icon icon="mdi:information-outline" className="text-primary text-lg" /><h3 className="text-lg font-medium">Existing Position Found</h3></div><Chip size="sm" color="primary" variant="flat">Same Pair</Chip></div></CardHeader>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = position.token0.address as Address;
  let t5;
  if ($[3] !== position.token0.symbol) {
    t5 = position.token0.symbol?.charAt(0);
    $[3] = position.token0.symbol;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== position.chainId || $[6] !== t4 || $[7] !== t5) {
    t6 = <TokenLogo chainId={position.chainId} tokenAddress={t4} size="sm" className="border-2 border-background" fallbackText={t5} />;
    $[5] = position.chainId;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = position.token1.address as Address;
  let t8;
  if ($[9] !== position.token1.symbol) {
    t8 = position.token1.symbol?.charAt(0);
    $[9] = position.token1.symbol;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== position.chainId || $[12] !== t7 || $[13] !== t8) {
    t9 = <TokenLogo chainId={position.chainId} tokenAddress={t7} size="sm" className="border-2 border-background" fallbackText={t8} />;
    $[11] = position.chainId;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t6 || $[16] !== t9) {
    t10 = <div className="flex items-center -space-x-2">{t6}{t9}</div>;
    $[15] = t6;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== position.token0.symbol || $[19] !== position.token1.symbol) {
    t11 = <div className="font-medium">{position.token0.symbol}/{position.token1.symbol}</div>;
    $[18] = position.token0.symbol;
    $[19] = position.token1.symbol;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== dexInfo.logo || $[22] !== position.dexName) {
    t12 = <img src={dexInfo.logo} alt={position.dexName} className="w-3 h-3" />;
    $[21] = dexInfo.logo;
    $[22] = position.dexName;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== position.dexName || $[25] !== t12) {
    t13 = <div className="text-xs text-default-500 flex items-center gap-1">{t12}{position.dexName}</div>;
    $[24] = position.dexName;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t11 || $[28] !== t13) {
    t14 = <div>{t11}{t13}</div>;
    $[27] = t11;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t10 || $[31] !== t14) {
    t15 = <div className="flex items-center gap-3">{t10}{t14}</div>;
    $[30] = t10;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  const t16 = getStatusColor(position);
  const t17 = getStatusText(position);
  let t18;
  if ($[33] !== t16 || $[34] !== t17) {
    t18 = <Chip size="sm" color={t16} variant="flat">{t17}</Chip>;
    $[33] = t16;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== t15 || $[37] !== t18) {
    t19 = <div className="flex items-center justify-between">{t15}{t18}</div>;
    $[36] = t15;
    $[37] = t18;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <Divider />;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <p className="text-default-500">Total Value</p>;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  let t22;
  if ($[41] !== position.totalValueUsd) {
    t22 = formatNumber(position.totalValueUsd, 2);
    $[41] = position.totalValueUsd;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== t22) {
    t23 = <div>{t21}<p className="font-medium">${t22}</p></div>;
    $[43] = t22;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <p className="text-default-500">Unclaimed Fees</p>;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  let t25;
  if ($[46] !== position.feesValueUsd) {
    t25 = formatNumber(position.feesValueUsd, 2);
    $[46] = position.feesValueUsd;
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  let t26;
  if ($[48] !== t25) {
    t26 = <div>{t24}<p className="font-medium text-success">${t25}</p></div>;
    $[48] = t25;
    $[49] = t26;
  } else {
    t26 = $[49];
  }
  let t27;
  if ($[50] !== position.token0.symbol) {
    t27 = <p className="text-default-500">{position.token0.symbol}</p>;
    $[50] = position.token0.symbol;
    $[51] = t27;
  } else {
    t27 = $[51];
  }
  const t28 = parseFloat(position.token0AmountFormatted);
  let t29;
  if ($[52] !== t28) {
    t29 = formatNumber(t28, 4);
    $[52] = t28;
    $[53] = t29;
  } else {
    t29 = $[53];
  }
  let t30;
  if ($[54] !== t29) {
    t30 = <p className="font-medium">{t29}</p>;
    $[54] = t29;
    $[55] = t30;
  } else {
    t30 = $[55];
  }
  let t31;
  if ($[56] !== t27 || $[57] !== t30) {
    t31 = <div>{t27}{t30}</div>;
    $[56] = t27;
    $[57] = t30;
    $[58] = t31;
  } else {
    t31 = $[58];
  }
  let t32;
  if ($[59] !== position.token1.symbol) {
    t32 = <p className="text-default-500">{position.token1.symbol}</p>;
    $[59] = position.token1.symbol;
    $[60] = t32;
  } else {
    t32 = $[60];
  }
  const t33 = parseFloat(position.token1AmountFormatted);
  let t34;
  if ($[61] !== t33) {
    t34 = formatNumber(t33, 4);
    $[61] = t33;
    $[62] = t34;
  } else {
    t34 = $[62];
  }
  let t35;
  if ($[63] !== t34) {
    t35 = <p className="font-medium">{t34}</p>;
    $[63] = t34;
    $[64] = t35;
  } else {
    t35 = $[64];
  }
  let t36;
  if ($[65] !== t32 || $[66] !== t35) {
    t36 = <div>{t32}{t35}</div>;
    $[65] = t32;
    $[66] = t35;
    $[67] = t36;
  } else {
    t36 = $[67];
  }
  let t37;
  if ($[68] !== t23 || $[69] !== t26 || $[70] !== t31 || $[71] !== t36) {
    t37 = <div className="grid grid-cols-2 gap-4 text-sm">{t23}{t26}{t31}{t36}</div>;
    $[68] = t23;
    $[69] = t26;
    $[70] = t31;
    $[71] = t36;
    $[72] = t37;
  } else {
    t37 = $[72];
  }
  let t38;
  if ($[73] !== position.range || $[74] !== position.token0.symbol || $[75] !== position.token1.symbol || $[76] !== position.version) {
    t38 = position.version === "v3" && <div className="pt-2 border-t border-divider"><div className="flex items-center justify-between mb-2"><p className="text-default-500 text-sm">Price Range</p><Chip size="sm" color={position.range.inRange ? "success" : "warning"} variant="flat">{position.range.inRange ? "Active" : "Inactive"}</Chip></div><p className="text-sm">{formatNumber(parseFloat(position.range.lowerPrice), 6)} - {formatNumber(parseFloat(position.range.upperPrice), 6)} {position.token1.symbol} per {position.token0.symbol}</p><p className="text-xs text-default-500 mt-1">Current: {formatNumber(parseFloat(position.range.currentPrice), 6)} {position.token1.symbol} per {position.token0.symbol}</p></div>;
    $[73] = position.range;
    $[74] = position.token0.symbol;
    $[75] = position.token1.symbol;
    $[76] = position.version;
    $[77] = t38;
  } else {
    t38 = $[77];
  }
  let t39;
  if ($[78] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = <Divider />;
    $[78] = t39;
  } else {
    t39 = $[78];
  }
  let t40;
  if ($[79] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = <Icon icon="mdi:minus" />;
    $[79] = t40;
  } else {
    t40 = $[79];
  }
  let t41;
  if ($[80] !== onRemoveClick || $[81] !== position) {
    t41 = <Button size="sm" variant="light" color="danger" startContent={t40} onPress={() => onRemoveClick?.(position)}>Remove Liquidity</Button>;
    $[80] = onRemoveClick;
    $[81] = position;
    $[82] = t41;
  } else {
    t41 = $[82];
  }
  let t42;
  if ($[83] !== position.feesValueUsd) {
    t42 = position.feesValueUsd > 0 && <Button size="sm" color="success" variant="flat" startContent={<Icon icon="mdi:currency-usd" />}>Claim ${formatNumber(position.feesValueUsd, 2)}</Button>;
    $[83] = position.feesValueUsd;
    $[84] = t42;
  } else {
    t42 = $[84];
  }
  let t43;
  let t44;
  if ($[85] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <div className="flex-1" />;
    t44 = <p className="text-xs text-default-500">Continue adding liquidity above to increase this position</p>;
    $[85] = t43;
    $[86] = t44;
  } else {
    t43 = $[85];
    t44 = $[86];
  }
  let t45;
  if ($[87] !== t41 || $[88] !== t42) {
    t45 = <div className="flex items-center gap-3">{t41}{t42}{t43}{t44}</div>;
    $[87] = t41;
    $[88] = t42;
    $[89] = t45;
  } else {
    t45 = $[89];
  }
  let t46;
  if ($[90] !== t19 || $[91] !== t37 || $[92] !== t38 || $[93] !== t45) {
    t46 = <Card>{t3}<CardBody className="pt-0"><div className="space-y-4">{t19}{t20}{t37}{t38}{t39}{t45}</div></CardBody></Card>;
    $[90] = t19;
    $[91] = t37;
    $[92] = t38;
    $[93] = t45;
    $[94] = t46;
  } else {
    t46 = $[94];
  }
  let t47;
  if ($[95] !== className || $[96] !== t46) {
    t47 = <><motion.div initial={t1} animate={t2} className={className}>{t46}</motion.div></>;
    $[95] = className;
    $[96] = t46;
    $[97] = t47;
  } else {
    t47 = $[97];
  }
  return t47;
}
function _temp2(position_1) {
  if (position_1.version === "v2") {
    return "V2 Pool";
  }
  return position_1.range.inRange ? "In Range" : "Out of Range";
}
function _temp(position_0) {
  if (position_0.version === "v2") {
    return "primary";
  }
  return position_0.range.inRange ? "success" : "warning";
}